import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { Container } from '@zurich/ui/legacy/components';
import { InfoTextCard } from '../';
export function Error500({ image }) {
    const { t } = useTranslation();
    return (_jsx(Container, { spacing: 5, children: _jsx(InfoTextCard, { title: t('portal:errors.500.title'), description: t('portal:errors.500.description'), illustration: image }) }));
}
